<template lang="pug">
  .vendor-list(v-loading="loading")
    .vendor-list__header
      el-breadcrumb(
        separator="/"
        style="padding-bottom: 30px"
      )
        el-breadcrumb-item {{ $t('供应商列表') }}
      .vendor-list__header__bottom
        .left
          tabs(
            :tabs="TABS.map(t => t.name)"
            :index="tabIndex"
            @change="changeTab"
          )
          span.vendor-list__invite-vendor(@click="$router.push('/vendor-management/new-vendor')") + {{ $t('添加供应商') }}
        .right
          template(v-if="tabIndex === 0")
            .vendor-list__search
              el-input(
                v-model="search"
                :placeholder="$t('供应商名称、广告主名称')"
                @keyup.enter.native="handleSearch"
              )
                el-button(
                  slot="append"
                  @click="handleSearch"
                ) {{ $t('搜索') }}
            i(
              v-if="isFilterCollapse"
              @click="isFilterCollapse = false"
            ).iconfont.icon-shaixuanxian
            i(
              v-else
              @click="isFilterCollapse = true"
            ).iconfont.icon-shaixuanmian
          template(v-else)
            .vendor-list__search
              el-input(
                v-model="invitedSearch"
                :placeholder="$t('供应商名称')"
                @keyup.enter.native="handleInvitedSearch "
              )
                el-button(
                  slot="append"
                  @click="handleInvitedSearch "
                ) {{ $t('搜索') }}
    .vendor-list__filter(v-if="!isFilterCollapse && tabIndex === 0")
      filter-vendor(@changeSelected="changeSelected")
    template(v-if="tabIndex === 0")
      .vendor-list__card(v-if="vendors && vendors.length !== 0")
        vendor-item(
          v-if="vendors && processedVendors.length === vendors.length && !processedVendors.some(v => !v)"
          v-for="vendor,index in processedVendors"
          :key="index"
          :itemData="vendor"
        )
        el-pagination.vendor-list__pagination(
          layout='prev, pager, next, jumper',
          :page-size='10',
          :total='total',
          :current-page.sync='currentPage',
          @current-change='fetchVendorList',
        )
      no-data(v-else)
    template(v-else)
      invited-list(
        ref="invitedList"
        :keyword="invitedSearch"
      )
</template>

<script>
import VendorItem from './components/VendorItem'
import FilterVendor from './components/FilterVendor'
import axios from 'axios'
import NoData from '@/components/NoData'
import Tabs from '@/components/Tabs'
import InvitedList from './components/InvitedList'

const TABS = [
  {
    name: '现有供应商'
  },
  {
    name: '待入库供应商'
  }
]

export default {
  components: {
    VendorItem,
    FilterVendor,
    NoData,
    Tabs,
    InvitedList
  },
  computed: {
    tabIndex () {
      return this.$store.state.vendor.vendorTabIndex
    }
  },
  data () {
    return {
      vendors: null,
      processedVendors: [],
      selected: {
        'Category': null,
        'Scope': null,
        'Company Size': null,
        'Vendor Type': null
      },
      currentPage: 1,
      total: null,
      search: '',
      invitedSearch: '',
      loading: false,
      TABS,
      isFilterCollapse: true
    }
  },
  watch: {
    processedVendors () {
      if (this.processedVendors.length === this.vendors.length && !this.processedVendors.some(v => !v)) {
        this.loading = false
      }
    }
  },
  mounted () {
    this.fetchVendorList()
  },
  methods: {
    fetchVendorList () {
      const params = {
        page_number: this.currentPage,
        page_size: 10,
        keyword: this.search
      }
      if (this.selected['category']) params.category_id = this.selected['category']
      if (this.selected['scope']) params.scope_id = this.selected['scope']
      if (this.selected['companySize']) params.company_size = this.selected['companySize']
      if (this.selected['vendorType']) params.vendor_type = this.selected['vendorType']
      if (this.selected['industry']) params.industry_id = this.selected['industry']
      if (this.selected['city']) params.city = this.selected['city']
      this.loading = true
      axios
        .get('/vendor/client/getVendorList', {params})
        .then((res) => {
          this.total = res.total_row
          this.vendors = res.table_data
          this.processedVendors = []
          this.processImg()
        })
        .catch(err => {
          this.loading = false
          throw new Error(err)
        })
    },
    handleSearch () {
      this.currentPage = 1
      this.selected['category'] = null
      this.selected['scope'] = null
      this.selected['companySize'] = null
      this.selected['vendorType'] = null
      this.fetchVendorList()
    },
    handleInvitedSearch () {
      this.$refs.invitedList.handleSearch()
    },
    changeSelected (selected) {
      this.selected = selected
      this.currentPage = 1
      this.fetchVendorList()
    },
    processImg () {
      const self = this
      this.vendors.forEach((d, i) => {
        if (d.download_url && d.download_url.match('^http')) {
          let img = new Image()
          img.src = d.download_url
          img.addEventListener('load', function () {
            d.height = this.naturalHeight
            d.width = this.naturalWidth
            self.processedVendors.splice(i, 0, d)
          })
        } else {
          self.processedVendors.splice(i, 0, d)
        }
      })
    },
    changeTab (index) {
      this.$store.commit('vendor/setVendorTabIndex', index)
    }
  }
}
</script>

<style lang="stylus">
.vendor-list
  margin -16px -32px
  height 100%

.vendor-list__header
  background-color #fff
  padding 16px 24px 0px 24px

.vendor-list__header__bottom
  align-items center
  display flex
  justify-content space-between
  .left
    display flex
    .campaign-tab
      margin-right 76px
      .el-tabs__nav-wrap::after
        background-color #fff
      .el-tabs__item
        margin-bottom 14px
        margin-top 7px
  .right
    display flex
    align-items center
    padding-bottom 16px
    .vendor-list__search
      margin-right 24px
    i
      color $main
      cursor pointer
.vendor-list__search
  display flex
  align-items center
  justify-content center
  .el-input
    width 462px
    height 32px
    input
      height 32px
    .el-input-group__append
      width 47px
      text-align center
      background $main
      color #ffffff
      font-size 14px
      border-color $main

.vendor-list__invite-vendor
  cursor pointer
  color $main
  margin-top 10px

.vendor-list__pagination.el-pagination
  margin-top 20px
  float right
  button
    background-color #f8f9fa
  .el-pager
    li
      background #f8f9fa

.vendor-list__card
  padding 24px 32px
  height 100vh !important
</style>
